import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Router"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getRouter: build.query<GetRouterApiResponse, GetRouterApiArg>({
        query: () => ({ url: `/Router` }),
        providesTags: ["Router"],
      }),
      postRouter: build.mutation<PostRouterApiResponse, PostRouterApiArg>({
        query: (queryArg) => ({
          url: `/Router`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Router"],
      }),
      getRouterById: build.query<GetRouterByIdApiResponse, GetRouterByIdApiArg>(
        {
          query: (queryArg) => ({ url: `/Router/${queryArg}` }),
          providesTags: ["Router"],
        }
      ),
      putRouterById: build.mutation<
        PutRouterByIdApiResponse,
        PutRouterByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Router/${queryArg.id}`,
          method: "PUT",
          body: queryArg.routerDto,
        }),
        invalidatesTags: ["Router"],
      }),
      deleteRouterById: build.mutation<
        DeleteRouterByIdApiResponse,
        DeleteRouterByIdApiArg
      >({
        query: (queryArg) => ({ url: `/Router/${queryArg}`, method: "DELETE" }),
        invalidatesTags: ["Router"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as routerApi };
export type GetRouterApiResponse = /** status 200 OK */ RouterDto[];
export type GetRouterApiArg = void;
export type PostRouterApiResponse = /** status 201 Created */ number;
export type PostRouterApiArg = RouterDto;
export type GetRouterByIdApiResponse = /** status 200 OK */ RouterDto;
export type GetRouterByIdApiArg = number;
export type PutRouterByIdApiResponse = /** status 200 OK */ void;
export type PutRouterByIdApiArg = {
  id: number;
  routerDto: RouterDto;
};
export type DeleteRouterByIdApiResponse = unknown;
export type DeleteRouterByIdApiArg = number;
export type RouterDto = {
  id: number;
  serialNumber: string;
  productionYear: number;
  firmware: string;
  macAddress?: string | null;
  comment?: string | null;
  commissioningDate?: string | null;
  maintenanceCycle?: string | null;
  timeSynchronisationType?: string | null;
  model: number;
  ipAddress?: string | null;
  subnetMask?: string | null;
  isUsed: boolean;
  wasEverUsed: boolean;
  available?: boolean;
  availabilityLastUpdated?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetRouterQuery,
  useLazyGetRouterQuery,
  usePostRouterMutation,
  useGetRouterByIdQuery,
  useLazyGetRouterByIdQuery,
  usePutRouterByIdMutation,
  useDeleteRouterByIdMutation,
} = injectedRtkApi;
